import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-responsive-modal';

const initialState = {
  open: false,
}

export default class UploadImageModal extends Component {

  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
  }

  state = initialState;

  componentDidMount() {
    window.uploadImage = (obj) => this.uploadImage(obj);
  }

  uploadImage = () => {
    this.setState({
      open: true,
    })
  }

  onClose = () => {
    this.setState(initialState);
  }

  render() {
    return (
      <Modal open={this.state.open} onClose={this.onClose} center styles={{ overlay: {zIndex: 10000}, closeIcon: { fill: 'white' } }}>
        <div style={{width: 700, height: 500}} className="middle-column">
          <div style={styles.header}>Upload Image</div>
          <button className="btn btn-danger">Upload Image</button>
        </div>
      </Modal>
    );
  }
}

const styles = {
  header: {
    height: 70,
    color: 'white',
    backgroundColor:'#2B363D',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingLeft: 20,
  },
};



// WEBPACK FOOTER //
// ./src/custom/UploadImageModal.js